import React from 'react';
import styles from '../Home.module.css';
import {getAssetUrl, getDisplayInitial} from '../utils';

interface PostAuthorAvatarProps {
  name: string;
  profilePicture?: string;
}

const PostAuthorAvatar: React.FC<PostAuthorAvatarProps> = ({name, profilePicture}) => {
  const avatarUrl = getAssetUrl(profilePicture);
  const [imageFailed, setImageFailed] = React.useState(false);

  React.useEffect(() => {
    setImageFailed(false);
  }, [avatarUrl]);

  return (
    <div className={styles.postAvatar}>
      {avatarUrl && !imageFailed ? (
        <img src={avatarUrl} alt="" onError={() => setImageFailed(true)} />
      ) : (
        getDisplayInitial(name)
      )}
    </div>
  );
};

export default React.memo(PostAuthorAvatar);
